import { render, staticRenderFns } from "./DeliveryNew.vue?vue&type=template&id=bc46867a&scoped=true"
import script from "./DeliveryNew.vue?vue&type=script&lang=js"
export * from "./DeliveryNew.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNew.vue?vue&type=style&index=0&id=bc46867a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc46867a",
  null
  
)

export default component.exports